require('./jquery.global');
require('./socket.io.global');
const CanvasJS = require('@canvasjs/charts');
import { isCallRecordingEnabled } from "./elements/CallRecording";
import { logCallEvent } from "./elements/LogCallEvent";
import "./elements/Icons";
import healthCheck from "./healthcheck";
import OutboundStatusUpdate from "./elements/OutboundStatusUpdate";
import moment from "moment/moment";
import { SlickDataView, SlickGrid, SlickGroupItemMetadataProvider } from "slickgrid";
import Sortable from "sortablejs";
import 'jquery-mask-plugin';
import 'jquery.cookie';
import 'tablesorter';
import 'moment-timezone';
import 'jquery.flot';
import 'jquery.flot/jquery.flot.categories';
import 'jquery.flot/jquery.flot.pie';
import 'jquery.flot/jquery.flot.time';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';
import 'dropzone';
import 'select2/dist/js/select2.full.min.js';
import 'jquery-simple-upload';
import 'readmore-js';
import '@claviska/jquery-minicolors';
import 'jquery.maskedinput/src/jquery.maskedinput.js';
import 'jquery-datetimepicker';
import 'timepicker';
import 'jquery-multiselect';
import intlTelInput from 'intl-tel-input';
import DOMPurify from 'dompurify';
import './intl_number_editor';
import 'jquery-toast-plugin';
import './elements/StatusModal';
import './address-4.01';
import { AsYouType, isPossiblePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js'

import "src/css/app.css";
import 'slickgrid/dist/styles/css/slick.grid.css';
import 'jquery-ui/dist/themes/base/jquery-ui.css';
import 'src/css/slick-grid-theme.css';
import 'dropzone/dist/dropzone.css';
import 'jquery-datetimepicker/jquery.datetimepicker.css';
import 'timepicker/jquery.timepicker.css';
import 'intl-tel-input/build/css/intlTelInput.min.css';
import 'src/css/jquery.toast.VN.css';
import 'src/css/address-4.01.css';

import "@claviska/jquery-dropdown/jquery.dropdown.min.css";
import "@claviska/jquery-dropdown/jquery.dropdown.min.js";
import 'select2/dist/css/select2.min.css';
import '@claviska/jquery-minicolors/jquery.minicolors.css';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
window.Quill = Quill;

window.isCallRecordingEnabled = isCallRecordingEnabled;
window.healthCheck = healthCheck;
window.SlickDataView = SlickDataView;
window.SlickGrid = SlickGrid;
window.SlickGroupItemMetadataProvider = SlickGroupItemMetadataProvider;
window.Sortable = Sortable;
window.healthCheck = healthCheck;
window.moment = moment;
window.CanvasJS = CanvasJS;
window.intlTelInput = intlTelInput;
window.OutboundStatusUpdate = OutboundStatusUpdate;
window.DOMPurify = DOMPurify;
window.logCallEvent = logCallEvent;
window.AsYouType = AsYouType;
window.isPossiblePhoneNumber = isPossiblePhoneNumber;
window.isValidPhoneNumber = isValidPhoneNumber;